export const iconFontAwesomeSocialShareNodes = (
	<i className="fa-solid fa-share-nodes"></i>
);
